import React from 'react';
import { FuelTypography } from '@frete.com/fuel-react';
import { HeaderPropsInterface } from './HeaderTypes';
import * as Styled from './HeaderStyles';

function Header({ title }: HeaderPropsInterface) {
  return (
    <Styled.Wrapper>
      <FuelTypography size="heading-md" weight="bold">
        {title}
      </FuelTypography>
    </Styled.Wrapper>
  );
}

export default Header;
